import { defineMessages } from 'react-intl'

const scope = `procurify.expense.features.getTravelDetails.TravelDetailContent`

export default defineMessages({
  travelHeading: {
    id: `${scope}.travelHeading`,
    defaultMessage: 'Travel #{travelId}',
  },
  requestedByLabel: {
    id: `${scope}.requestedByLabel`,
    defaultMessage: 'Requested by',
  },
  locationLabel: {
    id: `${scope}.locationLabel`,
    defaultMessage: 'Location',
  },
  departmentLabel: {
    id: `${scope}.departmentLabel`,
    defaultMessage: 'Department',
  },
  submittedLabel: {
    id: `${scope}.submittedLabel`,
    defaultMessage: 'Submitted',
  },
  lastModifiedLabel: {
    id: `${scope}.lastModifiedLabel`,
    defaultMessage: 'Last modified',
  },
  nextApproverLabel: {
    id: `${scope}.nextApproverLabel`,
    defaultMessage: 'Next approver',
  },
  statusStampApproved: {
    id: `${scope}.statusStampApproved`,
    defaultMessage: 'Approved',
  },
  statusStampDenied: {
    id: `${scope}.statusStampDenied`,
    defaultMessage: 'Denied',
  },
  approvedCaption: {
    id: `${scope}.approvedCaption`,
    defaultMessage: 'This travel request has been approved',
  },
  deniedCaption: {
    id: `${scope}.deniedCaption`,
    defaultMessage: 'This travel request has been denied',
  },
  itineraryAriaLabel: {
    id: `${scope}.itineraryAriaLabel`,
    defaultMessage: 'Itinerary for travel {travelId}',
  },
  transportationHeader: {
    id: `${scope}.transportationHeader`,
    defaultMessage: 'Transportation',
  },
  departureHeader: {
    id: `${scope}.departureHeader`,
    defaultMessage: 'Departure',
  },
  departureDateHeader: {
    id: `${scope}.departureDateHeader`,
    defaultMessage: 'Departure date',
  },
  arrivalHeader: {
    id: `${scope}.arrivalHeader`,
    defaultMessage: 'Arrival',
  },
  arrivalDateHeader: {
    id: `${scope}.arrivalDateHeader`,
    defaultMessage: 'Arrival date',
  },
  transportDriveLabel: {
    id: `${scope}.transportDriveLabel`,
    defaultMessage: 'Car',
  },
  transportFlightLabel: {
    id: `${scope}.transportFlightLabel`,
    defaultMessage: 'Flight',
  },
  transportRailLabel: {
    id: `${scope}.transportRailLabel`,
    defaultMessage: 'Train',
  },
  transportSailLabel: {
    id: `${scope}.transportSailLabel`,
    defaultMessage: 'Marine',
  },
  travelPurposeLabel: {
    id: `${scope}.travelPurposeLabel`,
    defaultMessage: 'Travel purpose',
  },
  travelDetailsLabel: {
    id: `${scope}.travelDetailsLabel`,
    defaultMessage: 'Travel details',
  },
  noDetailsText: {
    id: `${scope}.noDetailsText`,
    defaultMessage: 'No details specified',
  },
  requestedBudgetLabel: {
    id: `${scope}.requestedBudgetLabel`,
    defaultMessage: 'Requested budget',
  },
  historyTriggerAriaLabel: {
    id: `${scope}.historyTriggerAriaLabel`,
    defaultMessage: 'View approval history',
  },
  actionByLabel: {
    id: `${scope}.actionByLabel`,
    defaultMessage: 'Action by: {user}',
  },
  logRequestedBadge: {
    id: `${scope}.logRequestedBadge`,
    defaultMessage: 'Requested',
  },
  logApprovedBadge: {
    id: `${scope}.logApprovedBadge`,
    defaultMessage: 'Approved',
  },
  logDeniedBadge: {
    id: `${scope}.logDeniedBadge`,
    defaultMessage: 'Denied',
  },
  logPurchasedBadge: {
    id: `${scope}.logPurchasedBadge`,
    defaultMessage: 'Purchased',
  },
  logRequestedSentence: {
    id: `${scope}.logRequestedSentence`,
    defaultMessage: 'Travel #{travelId} was requested.',
  },
  logApprovedSentence: {
    id: `${scope}.logApprovedSentence`,
    defaultMessage: 'Travel #{travelId} was approved.',
  },
  logDeniedSentence: {
    id: `${scope}.logDeniedSentence`,
    defaultMessage: 'Travel #{travelId} was denied.',
  },
  logPurchasedSentence: {
    id: `${scope}.logPurchasedSentence`,
    defaultMessage: 'Travel #{travelId} was purchased.',
  },
})
